import React, { useState, useEffect } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { FaInstagram as Insta } from 'react-icons/fa';
import styled from 'styled-components';

const url = `/.netlify/functions/instagram`;

const InstaLinkStyles = styled.div`

    padding: 2rem 0;
    font-size: 3rem;
    text-align: center;
    @media (max-width: 650px) {
        font-size: 2rem;
    }

    svg {
            color: var(--grey);
            position: relative;
            top: 7px;
            margin-right: .75rem;
        }

    .insta-link {
        color: var(--grey);
        display: inline-block;
        border: 1px solid var(--grey);
        padding: .5rem 1.5rem;
        border-radius: .5rem;
        margin-bottom: 2.5rem;
        background-color: rgba(255, 255, 255, 0.75);
        transition: all .3s ease;

        &:hover {
            color: var(--white);
            background-color: var(--black);
        }

        &:hover > * {
            color: var(--white);
        }
    }
`;

const InstagramGridStyles = styled.div`
  display: grid;
  --cols: 4;
  grid-template-columns: repeat(var(--cols), 1fr);
  gap: 1.5rem;
  margin: 5rem 0;
  @media (max-width: 500px) {
      --cols: 2;
  }

  .instagram-photo {
    display: block;
    &:hover {
      box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14),
        0px 3px 3px -2px rgba(0, 0, 0, 0.12);
    }
  }
`;

const ErrorStyles = styled.div`
    grid-column: span 4;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 10rem;
    border-radius: 1rem;
    background-color: rgba(0, 0, 0, 0.14);

    p {
        margin: 0;
    }
`;

// Custom hook to get insta posts from serverless function
function useInstagram() {
    const [posts, setPosts] = useState([]);
    const [error, setError] = useState(false);
    useEffect(() => {
        fetch(url)
            .then(res => res.json())
            .then(data => {
            setPosts(data);
            setError(false);
        }).catch((err) => {
            console.log(err);
            setError(true);
        })
    }, []);
    return { 
        posts,
        error
    }
}

export default function Instagram() {
    const { posts, error } = useInstagram();
    const { site } = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    instagram
                }
            }
        }
    `);
    return (
        <>
            <InstaLinkStyles>
                <a href={site.siteMetadata.instagram} className="insta-link" target="_blank" rel="noreferrer">
                   <Insta /> follow me on Instagram
                </a>
            </InstaLinkStyles>
            <InstagramGridStyles>
                {error ? (
                    <ErrorStyles>
                        <p>something went wrong...can't get posts</p>
                    </ErrorStyles>
                ) : (
                    posts.map(gram => (
                        <div key={gram.id} className="instagram-photo">
                            <a href={gram.url} target="_blank" rel="noreferrer">
                                <img key={gram.id} src={gram.thumbnail} alt={gram.caption} />
                            </a>
                        </div>
                    ))
                )}
            </InstagramGridStyles>
        </>
    )
}